var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"anchor",class:_vm.customClass,on:{"click":_vm.handleClickToGenerateLink}},[_vm._v(_vm._s(_vm.readableName()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }